import { filterObject } from './object'

export const generateFilterParams = (pageNumber, pageSize, filters) => {
  const { purchasedStatus, subjectIds, resourceTypes, necessaryMaterials, implementationType } = filters
  delete filters.purchasedStatus
  delete filters.subjectIds
  delete filters.resourceTypes
  delete filters.necessaryMaterials
  delete filters.implementationType
  let params = new URLSearchParams()
  params.append('pageNumber', pageNumber)
  params.append('pageSize', pageSize)
  for (let attr in filters) if (filters[attr]) { params.append(`${attr}`, filters[attr]) }
  if (purchasedStatus) for (let status of purchasedStatus) { params.append('purchasedStatus', status) }
  if (subjectIds) for (let subjectId of subjectIds) { params.append('subjectIds', subjectId) }
  if (resourceTypes) for (let resourceType of resourceTypes) { params.append('resourceTypes', resourceType) }
  if (necessaryMaterials) for (let material of necessaryMaterials) { params.append('necessaryMaterials', material) }
  if (implementationType) for (let type of implementationType) { params.append('implementationType', type) }
  return params
}

export const generateFilters = (pageNumber, pageSize, filters) => {
  const params = new URLSearchParams()
  for (const key in filters) {
    if (Array.isArray(filters[key]) && filters[key].length) {
      for (const value of filters[key]) {
        params.append(key, value)
      }
    } else if (!Array.isArray(filters[key]) && (filters[key] || filters[key] === 0)) {
      params.append(key, filters[key])
    }
  }
  if (pageNumber) params.append('pageNumber', pageNumber)
  if (pageSize) params.append('pageSize', pageSize)
  return params
}

export const generateEducationalProgramFilters = filters => {
  const searchFilters = filterObject(filters)
  return searchFilters
}

export const generateEducationalProgramFilterParams = (pageNumber, pageSize, filters) => {
  if (filters) {
    delete filters.subjectIds
    delete filters.resourceTypes
    delete filters.necessaryMaterials
    delete filters.implementationType
  }
  let params = new URLSearchParams()
  params.append('pageNumber', pageNumber)
  params.append('pageSize', pageSize)
  for (let attr in filters) if (filters[attr]) { params.append(`${attr}`, filters[attr]) }
  return params
}
